<ul class="folder-tree list-unstyled mb-0">
    @if (showRoot()) {
        <li>
            <div class="folder-tree-item">
                <span class="folder-tree-toggle-placeholder"></span>
                <button type="button" class="folder-tree-row"
                    [class.is-selected]="isSelected(FolderTreeDestination.Root)"
                    [disabled]="isDisabled(FolderTreeDestination.Root)"
                    (click)="select(FolderTreeDestination.Root)">
                    <fa-duotone-icon icon="house" secondaryOpacity="0.4" class="me-2" />
                    <span class="folder-tree-name">{{ rootLabel() }}</span>
                    @if (isDisabled(FolderTreeDestination.Root) && disabledNote()) {
                        <span class="small ms-2 current-location-note">{{ disabledNote() }}</span>
                    }
                    <span class="badge bg-secondary-subtle text-secondary-emphasis ms-auto">
                        <fa-duotone-icon [icon]="DocumentUtilities.permissionIcon(rootPermission())" secondaryOpacity="0.4" class="me-1" />
                        {{ DocumentUtilities.permissionLabel(rootPermission()) }}
                    </span>
                </button>
            </div>
        </li>
    }

    @for (folder of rootFolders(); track folder.documentNodeId) {
        <ng-container *ngTemplateOutlet="branch; context: { folder: folder, depth: 0 }"></ng-container>
    }
</ul>

@if (rootFolders().length === 0 && emptyMessage()) {
    <p class="text-secondary small text-center my-4 mb-0">{{ emptyMessage() }}</p>
}

<ng-template #branch let-folder="folder" let-depth="depth">
    <li>
        <div class="folder-tree-item" [style.padding-left.rem]="0.75 + depth">
            @if (canExpand(folder)) {
                <button type="button" class="folder-tree-toggle"
                    (click)="toggleExpand(folder.documentNodeId, $event)"
                    [attr.aria-expanded]="isExpanded(folder.documentNodeId)"
                    [attr.aria-label]="isExpanded(folder.documentNodeId) ? 'Collapse' : 'Expand'">
                    @if (isLoading(folder.documentNodeId)) {
                        <span class="spinner-border spinner-border-sm" role="status" aria-label="Loading"></span>
                    } @else {
                        <fa-duotone-icon [icon]="isExpanded(folder.documentNodeId) ? 'chevron-down' : 'chevron-right'"
                            secondaryOpacity="0.9" />
                    }
                </button>
            } @else {
                <span class="folder-tree-toggle-placeholder"></span>
            }

            <button type="button" class="folder-tree-row"
                [class.is-selected]="isSelected(folder.documentNodeId)"
                [disabled]="isDisabled(folder.documentNodeId)"
                (click)="select(folder.documentNodeId)">
                <fa-duotone-icon [icon]="isExpanded(folder.documentNodeId) ? 'folder-open' : 'folder'"
                    [secondaryOpacity]="isExpanded(folder.documentNodeId) ? '0.4' : '0.9'" class="text-warning me-2" />
                <span class="folder-tree-name text-truncate" [msTooltip]="folder.name" msTooltipOnlyIfTruncated>{{ folder.name }}</span>
                @if (isDisabled(folder.documentNodeId) && disabledNote()) {
                    <span class="small ms-2 flex-shrink-0 current-location-note">{{ disabledNote() }}</span>
                }
                <span class="badge bg-secondary-subtle text-secondary-emphasis ms-auto">
                    <fa-duotone-icon [icon]="DocumentUtilities.permissionIcon(folder.permission)" secondaryOpacity="0.4" class="me-1" />
                    {{ DocumentUtilities.permissionLabel(folder.permission) }}
                </span>
            </button>
        </div>

        @if (isExpanded(folder.documentNodeId)) {
            <ul class="list-unstyled mb-0">
                @for (child of getChildren(folder.documentNodeId); track child.documentNodeId) {
                    <ng-container *ngTemplateOutlet="branch; context: { folder: child, depth: depth + 1 }"></ng-container>
                }
            </ul>
        }
    </li>
</ng-template>
